/* eslint-disable @nx/enforce-module-boundaries */
import { Button, Card, HStack, Spinner, Stack, Text } from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { JobsNotFoundIllustration } from '../404';
import { JobsListingContext } from '../context';
import { useRouter } from 'next/router';
import { SuggestedJobCard } from 'v4/components/jobs/suggested-job-card';

export const SearchJobsListing = forwardRef(({ ...props }, ref) => {
  const {
    saveJob,
    saveJobIsLoading,
    searchJobsListingPages,
    refetchSearchJobsListing,
    searchJobsListingIsFetching,
    searchJobsListingIsLoading,
    appliedJobsListing,
    refetchAppliedJobsListing,
    fetchSearchJobsListingNextPage,
    removeSavedJob,
    removeSavedJobIsLoading,
    searchJobsListingHasNextPage,
    applyDisc,
    setAppliedJob,
    savedJobsListing,
    filters,
  } = useContext(JobsListingContext);

  const { push } = useRouter();

  const [selected, setSelected] = useState();

  if (searchJobsListingIsLoading || searchJobsListingIsFetching)
    return (
      <HStack justifyContent="center" py={12}>
        <Spinner />
      </HStack>
    );

  const loc = [
    filters?.city ?? '',
    filters?.state ?? '',
    filters?.country ?? '',
  ]
    ?.filter?.((v) => v.length)
    ?.join?.(', ');

  return (
    <Stack>
      {searchJobsListingPages?.pages?.[0]?.results?.length > 0 ? (
        <Stack>
          <Stack px={2} pb={4} spacing={0}>
            {filters?.title?.length ? (
              // eslint-disable-next-line react/no-unescaped-entities
              <Text>"{filters?.title}" jobs</Text>
            ) : (
              ''
            )}
            {filters?.length && (
              <Text>
                {searchJobsListingPages?.pages?.[0]?.count ?? 0} Jobs found{' '}
                {loc?.length ? ` in ${loc}` : ''}
              </Text>
            )}
          </Stack>
          <HStack alignItems="stretch" spacing={0} flexWrap="wrap" gap={6} w="100%" px={[2, 0]}>
            {searchJobsListingPages?.pages?.map((page, pageIndex) => {
              return (
                <>
                  {page?.results?.map((job, jobIndex) => {
                    const isApplied = appliedJobsListing?.find?.(
                      (aj) => aj?.job_details?.id === job?.id
                    );
                    const isSaved = savedJobsListing?.find?.(
                      (sj) => sj?.job_details?.id === job?.id
                    );
                    return (
                      <Card
                        h={[null,"280px"]}
                        key={jobIndex}
                        w={['100%', '100%', '48.2%', '32.12%']}
                        jobIndex={pageIndex + '-' + jobIndex}
                        p={4}
                        border="1px solid #D4D4D4"
                        boxShadow="none"
                      >
                        <SuggestedJobCard
                          href={'/jobs/' + job?.id}
                          onSaveClick={(e) => {
                            setSelected(job);
                            if (isSaved) {
                              removeSavedJob(job);
                            } else {
                              saveJob({ job_id: job?.id });
                            }
                          }}
                          onViewDetailsClick={(e) => push('/jobs/' + job?.id)}
                          job={job}
                          saveLoading={
                            selected?.id === job?.id && removeSavedJobIsLoading
                          }
                          isSaved={isSaved}
                          isApplied={isApplied}
                          onApplyClick={(e) => {
                            if (
                              typeof window !== 'undefined' &&
                              job?.how_to_apply === 'EXTERNAL'
                            ) {
                              window.open(job?.how_to_apply_text, '_blank');
                            } else {
                              setAppliedJob?.(job);
                              applyDisc?.onOpen?.();
                            }
                          }}
                        />
                      </Card>
                    );
                  })}
                </>
              );
            })}
          </HStack>
          {searchJobsListingHasNextPage ? (
            <HStack w="100%" justifyContent="center">
              <Button
                onClick={fetchSearchJobsListingNextPage}
                vairant="secondary"
              >
                Load More
              </Button>
            </HStack>
          ) : (
            ''
          )}
        </Stack>
      ) : (
        <Stack alignItems="center" justifyContent="center" py="12">
          <JobsNotFoundIllustration />
          <Text>
            Search for a job now and we will work on finding you more suggested
            jobs!
          </Text>
        </Stack>
      )}
    </Stack>
  );
});
